import { Pests } from "@station/domain/models/pest.model";
import type { PestRepository } from "@station/domain/repositories/pest.repository";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";

@injectable()
export class PestGetAllUseCase {
    constructor(
        @inject(stationsTypes.repositories.PestRepository)
        private readonly pestRepository: PestRepository,
    ) {}

    async execute(stationId: string): Promise<Pests> {
        const pestsResult = await this.pestRepository.getAllPest(stationId);

        return pestsResult.match(
            (pests) => pests,
            () => Pests.empty(),
        );
    }
}
